<mat-form-field appearance="outline" [ngClass]="readOnly ? 'disabled' : ''">
    <mat-label>{{ label ?? placeholder }}</mat-label>
    <textarea
        [required]="control.isRequired"
        #message
        matInput
        [formControl]="control"
        [name]="control.name"
        [maxlength]="control.maxLengthValue"
        [readonly]="readOnly"
        [disabled]="readOnly"
        [placeholder]="placeholder"
    ></textarea>
    <mat-hint *ngIf="displayHint" align="end">{{ message.value.length }} / {{ control.maxLengthValue }}</mat-hint>
    <!-- https://github.com/angular/material2/issues/7739 : Vive la bidouille ! -->
    <ng-template ngFor let-key [ngForOf]="control.validationKeys" ngProjectAs="mat-error">
        <mat-error *ngIf="control.hasError(key)">
            {{ control.getErrorMessage(key) }}
        </mat-error>
    </ng-template>
</mat-form-field>
